export default function isNotNumeric(val: string) {
  const notNumericPattern = /[^0-9]/g;

  return val.match(notNumericPattern);
}
